import script from "./Rooms.vue?vue&type=script&lang=ts&setup=true"
export * from "./Rooms.vue?vue&type=script&lang=ts&setup=true"

import "./Rooms.vue?vue&type=style&index=0&id=728d25c6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-728d25c6"]])

export default __exports__